<div class="not-found-container">
  <div class="image-container">
    <img src="assets/fondos/404-client.svg" alt="" />
  </div>

  <div class="info-container">
    <p>
      Página no encontrada. Es posible que el enlace esté desactualizado o que
      el recurso haya sido removido del servidor.
    </p>

    <button [routerLink]="['/home']">Volver a la página principal</button>
  </div>
</div>
